import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class AssetDetailVm {
	assetId: number;
	assetTypeId?: number;
	tankAssetNumber?: string;
	assetType?: string;
	domicile?: string;
	domicileId?: number;
	status?: any;
	statusStr?: string;
	imageFileName?: string;
	thumbnailFileName?: string;
	companyOwned?: string;
	billableRatePerHour?: number;
	file?: any;
	dateOfExpectedRepair?: Date;
	subContracted: boolean;
	loadBearing: boolean;
	powerTakeOff: boolean;
	notes?: string;
	siteLocation?: any;
	siteId?: number;
	assignedSiteLocation?: string;
	isUpdatedOffline: boolean;
	canDelete: boolean;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'assetId': new UntypedFormControl(0, [...(validators['assetId'] ?? []), ...[Validators.required]]),
			'assetTypeId': new UntypedFormControl(null, [...(validators['assetTypeId'] ?? []), ...[]]),
			'tankAssetNumber': new UntypedFormControl(null, [...(validators['tankAssetNumber'] ?? []), ...[Validators.maxLength(20), Validators.required]]),
			'assetType': new UntypedFormControl(null, [...(validators['assetType'] ?? []), ...[]]),
			'domicile': new UntypedFormControl(null, [...(validators['domicile'] ?? []), ...[]]),
			'domicileId': new UntypedFormControl(null, [...(validators['domicileId'] ?? []), ...[]]),
			'status': new UntypedFormControl(null, [...(validators['status'] ?? []), ...[]]),
			'statusStr': new UntypedFormControl(null, [...(validators['statusStr'] ?? []), ...[]]),
			'imageFileName': new UntypedFormControl(null, [...(validators['imageFileName'] ?? []), ...[]]),
			'thumbnailFileName': new UntypedFormControl(null, [...(validators['thumbnailFileName'] ?? []), ...[]]),
			'companyOwned': new UntypedFormControl(null, [...(validators['companyOwned'] ?? []), ...[Validators.maxLength(20)]]),
			'billableRatePerHour': new UntypedFormControl(null, [...(validators['billableRatePerHour'] ?? []), ...[]]),
			'file': new UntypedFormControl(null, [...(validators['file'] ?? []), ...[]]),
			'dateOfExpectedRepair': new UntypedFormControl(null, [...(validators['dateOfExpectedRepair'] ?? []), ...[]]),
			'subContracted': new UntypedFormControl(false, [...(validators['subContracted'] ?? []), ...[]]),
			'loadBearing': new UntypedFormControl(false, [...(validators['loadBearing'] ?? []), ...[]]),
			'powerTakeOff': new UntypedFormControl(false, [...(validators['powerTakeOff'] ?? []), ...[]]),
			'notes': new UntypedFormControl(null, [...(validators['notes'] ?? []), ...[]]),
			'siteLocation': new UntypedFormControl(null, [...(validators['siteLocation'] ?? []), ...[]]),
			'siteId': new UntypedFormControl(null, [...(validators['siteId'] ?? []), ...[]]),
			'assignedSiteLocation': new UntypedFormControl(null, [...(validators['assignedSiteLocation'] ?? []), ...[]]),
			'isUpdatedOffline': new UntypedFormControl(false, [...(validators['isUpdatedOffline'] ?? []), ...[]]),
			'canDelete': new UntypedFormControl(false, [...(validators['canDelete'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['tankAssetNumber', {"orderId":0,"sortColumn":"tankAssetNumber","searchColumn":"tankAssetNumber","includeInExcel":true,"exportColumn":null,"displayName":"Asset Number","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['imageFileName', {"orderId":1,"sortColumn":"imageFileName","searchColumn":"imageFileName","includeInExcel":true,"exportColumn":null,"displayName":"Image","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['assetType', {"orderId":2,"sortColumn":"assetType","searchColumn":"assetType","includeInExcel":true,"exportColumn":null,"displayName":"Asset Type","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['domicile', {"orderId":3,"sortColumn":"domicile","searchColumn":"domicile","includeInExcel":true,"exportColumn":null,"displayName":"Domicile","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['statusStr', {"orderId":4,"sortColumn":"statusStr","searchColumn":"statusStr","includeInExcel":true,"exportColumn":null,"displayName":"Status","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['powerTakeOff', {"orderId":5,"sortColumn":"powerTakeOff","searchColumn":"powerTakeOff","includeInExcel":true,"exportColumn":null,"displayName":"PTO","isVisible":true,"canSearch":false,"multiSearchCellClasses":null}],
			['assignedSiteLocation', {"orderId":6,"sortColumn":"assignedSiteLocation","searchColumn":"assignedSiteLocation","includeInExcel":true,"exportColumn":null,"displayName":"Assigned Site Location","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['canDelete', {"orderId":7,"sortColumn":"canDelete","searchColumn":"canDelete","includeInExcel":true,"exportColumn":null,"displayName":"Delete","isVisible":true,"canSearch":false,"multiSearchCellClasses":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): AssetDetailVmFromFg {
		return new AssetDetailVmFromFg(fg);
	}
}

export class AssetDetailVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get assetId(): number {
		return this.fg.get('assetId').value;
	}
	set assetId(val) {
		this.fg.get('assetId').setValue(val);
	}

	get assetTypeId(): number {
		return this.fg.get('assetTypeId').value;
	}
	set assetTypeId(val) {
		this.fg.get('assetTypeId').setValue(val);
	}

	get tankAssetNumber(): string {
		return this.fg.get('tankAssetNumber').value;
	}
	set tankAssetNumber(val) {
		this.fg.get('tankAssetNumber').setValue(val);
	}

	get assetType(): string {
		return this.fg.get('assetType').value;
	}
	set assetType(val) {
		this.fg.get('assetType').setValue(val);
	}

	get domicile(): string {
		return this.fg.get('domicile').value;
	}
	set domicile(val) {
		this.fg.get('domicile').setValue(val);
	}

	get domicileId(): number {
		return this.fg.get('domicileId').value;
	}
	set domicileId(val) {
		this.fg.get('domicileId').setValue(val);
	}

	get status(): any {
		return this.fg.get('status').value;
	}
	set status(val) {
		this.fg.get('status').setValue(val);
	}

	get statusStr(): string {
		return this.fg.get('statusStr').value;
	}
	set statusStr(val) {
		this.fg.get('statusStr').setValue(val);
	}

	get imageFileName(): string {
		return this.fg.get('imageFileName').value;
	}
	set imageFileName(val) {
		this.fg.get('imageFileName').setValue(val);
	}

	get thumbnailFileName(): string {
		return this.fg.get('thumbnailFileName').value;
	}
	set thumbnailFileName(val) {
		this.fg.get('thumbnailFileName').setValue(val);
	}

	get companyOwned(): string {
		return this.fg.get('companyOwned').value;
	}
	set companyOwned(val) {
		this.fg.get('companyOwned').setValue(val);
	}

	get billableRatePerHour(): number {
		return this.fg.get('billableRatePerHour').value;
	}
	set billableRatePerHour(val) {
		this.fg.get('billableRatePerHour').setValue(val);
	}

	get file(): any {
		return this.fg.get('file').value;
	}
	set file(val) {
		this.fg.get('file').setValue(val);
	}

	get dateOfExpectedRepair(): Date {
		return this.fg.get('dateOfExpectedRepair').value;
	}
	set dateOfExpectedRepair(val) {
		this.fg.get('dateOfExpectedRepair').setValue(val);
	}

	get subContracted(): boolean {
		return this.fg.get('subContracted').value;
	}
	set subContracted(val) {
		this.fg.get('subContracted').setValue(val);
	}

	get loadBearing(): boolean {
		return this.fg.get('loadBearing').value;
	}
	set loadBearing(val) {
		this.fg.get('loadBearing').setValue(val);
	}

	get powerTakeOff(): boolean {
		return this.fg.get('powerTakeOff').value;
	}
	set powerTakeOff(val) {
		this.fg.get('powerTakeOff').setValue(val);
	}

	get notes(): string {
		return this.fg.get('notes').value;
	}
	set notes(val) {
		this.fg.get('notes').setValue(val);
	}

	get siteLocation(): any {
		return this.fg.get('siteLocation').value;
	}
	set siteLocation(val) {
		this.fg.get('siteLocation').setValue(val);
	}

	get siteId(): number {
		return this.fg.get('siteId').value;
	}
	set siteId(val) {
		this.fg.get('siteId').setValue(val);
	}

	get assignedSiteLocation(): string {
		return this.fg.get('assignedSiteLocation').value;
	}
	set assignedSiteLocation(val) {
		this.fg.get('assignedSiteLocation').setValue(val);
	}

	get isUpdatedOffline(): boolean {
		return this.fg.get('isUpdatedOffline').value;
	}
	set isUpdatedOffline(val) {
		this.fg.get('isUpdatedOffline').setValue(val);
	}

	get canDelete(): boolean {
		return this.fg.get('canDelete').value;
	}
	set canDelete(val) {
		this.fg.get('canDelete').setValue(val);
	}
}
